import {buildAssistantEntityContext, type AssistantEntityContext} from '@dms/ai-assistant';
import type {SaleVehicleResponseBody} from '@dms/api/vehicle';

interface VehicleIdentity {
  id: string;
  title?: string | null;
}

/**
 * Records loaded by a mounted vehicle page. Returns `undefined` until the loaded vehicle belongs to
 * the route id, so a record switch cannot leak the previous vehicle or its business case.
 */
export const getVehicleAssistantEntities = (
  vehicleId: string,
  vehicle: VehicleIdentity | undefined,
  saleVehicle: Pick<SaleVehicleResponseBody, 'saleBusinessCaseId' | 'vehicleId'> | undefined
): AssistantEntityContext | undefined => {
  if (vehicle?.id !== vehicleId) {
    return undefined;
  }

  return buildAssistantEntityContext({
    vehicle: {id: vehicle.id, label: vehicle.title},
    businessCase: saleVehicle?.vehicleId === vehicleId ? saleVehicle.saleBusinessCaseId : undefined,
  });
};
